import ServicesTypes from './types.js';
const { CONTENT_STATE } = ServicesTypes;

/**
 * Utility functions associated with the services layer.
 *
 * @class ServicesUtils
 * @name utils
 * @memberof Mojito.Services.Common
 */
class ServicesUtils {
    /**
     * Creates slice pending handler for particular state property.
     *
     * @param {string} stateProp - The name of the state property to assign pending item state.
     *
     * @returns {Function} Slice reducer function accepts state as first arg and instance of {@link Mojito.Core.Services.redux.Action|redux action} as a second arg.
     * @function Mojito.Services.Common.utils.createPendingHandler
     */
    static createPendingHandler(stateProp) {
        return (state, { payload: itemIds }) => {
            itemIds &&
                itemIds.forEach(itemId => {
                    const currentState = state[stateProp][itemId];
                    // The item can be already available in store but not being subscribed yet. For example in case of prefetch, vision content preload or SSR.
                    // In this case we don't need to apply PENDING state to not force skeletons and to not break TIMELINE_RECORD_TYPES.PAGE_READY metric reporting.
                    // Note: this check might be not needed after MOJ-14489 implementation
                    if (currentState !== CONTENT_STATE.AVAILABLE) {
                        state[stateProp][itemId] = CONTENT_STATE.PENDING;
                    }
                });
        };
    }

    /**
     * Checks if content loading has been finalized.
     * It is considered to be finalized if loadingState is either {@link Mojito.Services.Common.types.CONTENT_STATE.AVAILABLE|AVAILABLE} or {@link Mojito.Services.Common.types.CONTENT_STATE.UNAVAILABLE|UNAVAILABLE}.
     *
     * @param {Mojito.Services.Common.types.CONTENT_STATE} loadingState - Loading state of content.
     *
     * @returns {boolean} True if loading is done.
     * @function Mojito.Services.Common.utils.isContentLoadDone
     */
    static isContentLoadDone(loadingState) {
        return (
            loadingState === CONTENT_STATE.AVAILABLE || loadingState === CONTENT_STATE.UNAVAILABLE
        );
    }
}

export default ServicesUtils;
